import _ from 'lodash'

import FormBaseValidator from './FormBaseValidator'

export default {
  mixins: [FormBaseValidator],

  methods: {
    validationErrors (field) {
      return this.validationErrorBag.collect(field)
    },

    validationHasErrors (field) {
      return this.validationErrorBag.has(field)
    },

    validateField (field) {
      this.$validator.validate(field)
    },

    graphQLValidation (graphQLErrors) {
      _.forEach(graphQLErrors, (errors, field) => {
        this.validationErrorBag.add({
          id: 'graphql-' + field,
          field,
          msg: errors[0]
        })
      })
    },

    resetGraphQLValidation (GraphQLField = null) {
      if (GraphQLField) {
        this.validationErrorBag.removeById('graphql-' + GraphQLField)

        return
      }

      _.forEach(this.validationErrorBag.collect(), (errors, field) => {
        this.validationErrorBag.removeById('graphql-' + field)
      })
    }
  }
}
